module.exports = __webpack_public_path__ + "img/chart-img-1.f164f523.png";